import CompanyDriverInformation from "./DriverInformation/Driver.Company";

const Component = {
  CompanyDriverInformation,
};

export default Component;
